<template>
    <div v-if="indexed">
        <div v-if="parsedUrl['special'] == 'pets'">
            <br>
            <span class="font-nova-regular text-so-blue">Currently Showing Pet Friendly Properties: </span>
            <a class="underline text-blue-700" :href="url">{{ allText }}</a>
        </div>
        <div v-if="parsedUrl['special'] == 'large'">
            <br>
            <span class="font-nova-regular text-so-blue">Currently Showing Large Properties: </span>
            <a class="underline text-blue-700" :href="url">{{ allText }}</a>
        </div>
        <div v-if="parsedUrl['special'] == 'wheelchair'">
            <br>
            <span class="font-nova-regular text-so-blue">Currently Showing Accessible Properties: </span>
            <a class="underline text-blue-700" :href="url">{{ allText }}</a>
        </div>
        <div v-if="parsedUrl['special'] == 'late'">
            <br>
            <span class="font-nova-regular text-so-blue">Currently Showing Last Minute Properties: </span>
            <a class="underline text-blue-700" :href="url">{{ allText }}</a>
        </div>
        <div v-if="parsedUrl['special'] == undefined && quickLinks.length !== 0">
            <br>
            <span class="font-nova-regular text-so-blue">Quick Filters: </span><br>
            <template v-if="showPets"><a class="underline text-blue-700" :href="url +'pets/'">{{ petText }}</a> |&nbsp;</template>
            <template v-if="showLate"><a class="underline text-blue-700" :href="url +'late/'">{{ lateText }}</a> |&nbsp;</template>
            <template v-if="showLarge"><a class="underline text-blue-700" :href="url +'large/'">{{ largeText }}</a> |&nbsp;</template>
            <template v-if="showAccessible"><a class="underline text-blue-700" :href="url +'wheelchair/'">{{ accessibleText }}</a></template>


        </div>
    </div>
</template>

<script>
export default {
    name: "QuickFilterComponent",
    props: ["parsedUrl", "defaultType", "location", "indexed", "quickLinks"],
    methods: {
        titleCase(str) {
            return str
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        },
    },
    computed: {
        url() {
            return '/' + this.parsedUrl['location'] + '/';
        },
        showPets() {
            //if quickLinks is not null and hasPets is true
            if (this.quickLinks && this.quickLinks.hasPets) {
                return true;
            }
        },
        showLate() {
            //if quickLinks is not null and hasLate is true
            if (this.quickLinks && this.quickLinks.hasLate) {
                return true;
            }
        },
        showLarge() {
            //if quickLinks is not null and hasLarge is true
            if (this.quickLinks && this.quickLinks.hasLarge) {
                return true;
            }
        },
        showAccessible() {
            //if quickLinks is not null and hasWheelchair is true
            if (this.quickLinks && this.quickLinks.hasWheelchair) {
                return true;
            }
        },
        petText() {
            let petText = this.titleCase(this.location) + '\u00A0Pet\u00A0Friendly\u00A0' + this.titleCase(this.defaultType) + 's';
            return petText.replace(/ /g, "\u00A0");
        },
        lateText() {
            let lateText = 'Last\u00A0Minute ' + this.titleCase(this.location) + '\u00A0' + this.titleCase(this.defaultType) + 's';
            return lateText.replace(/ /g, "\u00A0");
        },
        largeText() {
            let largeText = 'Large\u00A0' + this.titleCase(this.defaultType) + 's\u00A0in\u00A0' + this.titleCase(this.location);
            return largeText.replace(/ /g, "\u00A0");
        },
        accessibleText() {
            let accessibleText = 'Accessible\u00A0' + this.titleCase(this.defaultType) + 's\u00A0in\u00A0' + this.titleCase(this.location);
            return accessibleText.replace(/ /g, "\u00A0");
        },
        allText() {
            return 'Show\u00A0All\u00A0' + this.titleCase(this.defaultType) + 's\u00A0in\u00A0' + this.titleCase(this.location);
        },
    },

}
</script>
